import { render, staticRenderFns } from "./ApfUploadPaymentInfo.vue?vue&type=template&id=a71aa18c&scoped=true"
import script from "./ApfUploadPaymentInfo.vue?vue&type=script&lang=js"
export * from "./ApfUploadPaymentInfo.vue?vue&type=script&lang=js"
import style0 from "./ApfUploadPaymentInfo.vue?vue&type=style&index=0&id=a71aa18c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71aa18c",
  null
  
)

export default component.exports